/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { MarketArea } from '@scenario/models/market-area.model';
import { RootState } from '@store/create-store';
import {
  retrieveMarketAreasFailure,
  retrieveMarketAreasSuccess,
} from '@store/scenario/market-areas/market-areas-slice';

export const retrieveMarketAreasEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('marketAreas/retrieveMarketAreas'),
    concatMap((_action: Action) =>
      from(dependencies.marketAreaGateway.retrieveAll()).pipe(
        map((marketAreas: MarketArea[]) => retrieveMarketAreasSuccess(marketAreas)),
        catchError(() => of(retrieveMarketAreasFailure('Fail to retrieve market areas'))),
      ),
    ),
  );
